export default "__VITE_ASSET__C7PIYeeP__"